import { Booking } from "../interface/Booking";
import axios from "axios";
import { DateTime } from "luxon";

export const getGymBookings = async (params: {
  gymId: string;
  date: string;
  page?: number;
  limit?: number;
}): Promise<{ data: Booking[]; canFetchMore: boolean }> => {
  const { gymId, date, page = 1, limit = 10 } = params;
  const startDate = DateTime.fromISO(date).set({
    hour: 0,
    millisecond: 0,
    minute: 0,
    second: 0,
  });

  const endDate = DateTime.fromISO(date).set({
    hour: 23,
    minute: 59,
    second: 59,
    millisecond: 59,
  });

  const { data } = await axios.get<{ data: Booking[] }>(
    `${
      process.env.REACT_APP_MEMBR_API_URL
    }/v1/public/gyms/${gymId}/bookings?page=${page}&page_size=${limit}&from_date=${startDate
      .toJSDate()
      .toISOString()}&to_date=${endDate.toJSDate().toISOString()}`,
  );
  return {
    data: data.data,
    canFetchMore: data.data.length === limit,
  };
};
